import pageElements from './pageElements'
import photograms from './photograms'
import portraits from './portraits'
import centralParis from './centralParis'
import britishPhotography from './britishPhotography'
import parisOutskirts from './parisOutskirts'
import gardens from './gardens'

export default {
  pageElements,
  photograms,
  portraits,
  centralParis,
  britishPhotography,
  parisOutskirts,
  gardens
}
